import React, {useState} from 'react'
import {createProductionLine} from "../../services/serviceProductionLine";
import {Button, Form, Input, Modal} from "antd";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";

const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}


const ProductionLineCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [loadings, setLoadings] = useState([])


    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            name: list.productionLineName,
            code: list.productionLineCode
        }
        createProductionLine(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                title={'Yeni Üretim Hattı Ekle'}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            onClick={() => form.submit()}
                            loading={loadings[0]}
                    >Kaydet</Button>,
                    <Button  key={'CancelButton'} onClick={() => modalCloser()} >Kapat</Button>
                ]}
            >
                <Form
                    form={form}
                    {...formLayout}
                    onFinish={() => handleSubmit(form.getFieldsValue())}
                >

                    <Form.Item
                        label={'Üretim Hattı Adı'}
                        name={'productionLineName'}
                        rules={[
                            {required:true, message: 'Üretim Hattı Adı Boş Bırakılamaz'},
                            {min: 5, max: 300, message: 'Üretim Hattı Adı En Az 5 En Fazla 300 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        label={'Üretim Hattı Kodu'}
                        name={'productionLineCode'}
                        rules={[
                            {required: true, message: 'Üretim Hattı Kodu Boş Bırakılamaz'},
                            {pattern: /^\S*$/gm, message: 'Üretim Hattı Kodu Alanı Boşluk İçeremez'},
                            {min: 3, max: 20, message: 'Üretim Hattı Kodu En az 3 En Fazla 20 Karakter Olabilir'}
                        ]}
                    >
                        <Input />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default ProductionLineCreate